// extracted by mini-css-extract-plugin
module.exports = {"Paid":"ExpensesList_Paid__3NeJd","Issued":"ExpensesList_Issued__17L3u"};